import { render, staticRenderFns } from "./add-or-update.vue?vue&type=template&id=3eefd85a&"
import script from "./add-or-update.vue?vue&type=script&lang=js&"
export * from "./add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports